// eslint-disable-next-line import/prefer-default-export
export function useImageProcessing(options = {}) {
  const { quality = 0.8, idealSize = 500000 /* As byte === 0.5 Mb */ } =
    options;

  let originalFileName = "";
  let originalFileType = "";

  const needToResize = (fileBlob) => {
    const fileSize = fileBlob.size;
    return fileSize > idealSize;
  };

  const resizeToFile = (fileBlob) =>
    new Promise((resolve) => {
      originalFileName = fileBlob.name;
      originalFileType = fileBlob.type;
      const fileBlobSize = fileBlob.size;
      const reader = new FileReader();
      reader.readAsDataURL(fileBlob);
      reader.onload = () => {
        const resizingFactor = Math.sqrt(idealSize / fileBlobSize);
        const typeAdjustment = originalFileType === "image/gif" ? 0.6 : 1;
        const img = new Image();
        img.src = reader.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = Math.floor(
            img.width * resizingFactor * typeAdjustment,
          );
          canvas.height = Math.floor(
            img.height * resizingFactor * typeAdjustment,
          );
          canvas
            .getContext("2d")
            .drawImage(img, 0, 0, canvas.width, canvas.height);
          canvas.toBlob(
            (blob) =>
              resolve(
                new File([blob], originalFileName, { type: originalFileType }),
              ),
            originalFileType,
            quality,
          );
        };
      };
    });

  return {
    needToResize,
    resizeToFile,
  };
}
